"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmationButtons = exports.ConfirmationContext = void 0;
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-ui/lib/utils/translation");
var ConfirmDialog_1 = require("components/modals/ConfirmDialog");
var React = require("react");
var CONFIRMATION_CONTEXT_BODY_KEYS = {
    resync: 'vektorio/resyncConfirmation/modal/body',
    unlink: 'vektorio/confirmation/modal/body'
};
var ConfirmationContext = function (props) {
    var action = props.action, name = props.name;
    var body = (0, translation_1.getLocalization)(CONFIRMATION_CONTEXT_BODY_KEYS[action]);
    var title = (0, translation_1.getLocalization)('genericWarningConfirmationModal/title');
    return (React.createElement(React.Fragment, null,
        React.createElement(ConfirmDialog_1.Exclamation, null),
        React.createElement("div", null,
            React.createElement("div", { className: "title please-confirm-text" },
                React.createElement("h2", { className: "title" }, title)),
            React.createElement("div", { className: "text" },
                React.createElement("p", null, body),
                React.createElement("p", null, name)))));
};
exports.ConfirmationContext = ConfirmationContext;
var ConfirmationButtons = function (props) {
    var actionHandler = props.actionHandler, setIsModalOpen = props.setIsModalOpen;
    var cancelLabel = (0, translation_1.getLocalization)('genericWarningConfirmationModal/cancel');
    var confirmLabel = (0, translation_1.getLocalization)('genericWarningConfirmationModal/confirm');
    var confirm = function () {
        actionHandler();
        setIsModalOpen();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(sok_ui_1.Button, { color: "red", text: confirmLabel, onClick: confirm }),
        React.createElement(sok_ui_1.Button, { color: "dark-gray", text: cancelLabel, onClick: setIsModalOpen })));
};
exports.ConfirmationButtons = ConfirmationButtons;
